export const INPUT_PROPS = {
  id: {
    type: String,
    required: false,
  },
  modelValue: {
    type: String,
    default: '',
  },
  errors: {
    type: Array,
    default: () => [],
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  helpText: {
    type: String,
    required: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  autoFocus: {
    type: Boolean,
    default: false,
  },
  autoSelect: {
    type: Boolean,
    default: false,
  },
  noMargin: {
    type: Boolean,
    default: false,
  }
}

export const CARD_PROPS = {
  title: {
    type: String,
    required: false,
  },
  rawTitle: {
    type: String,
    required: false,
  },
  icon: {
    type: String,
    required: false,
  },
  iconStyle: {
    type: String,
    required: false,
  },
  image: {
    type: String,
    required: false,
  },
  subTitle: {
    type: String,
    required: false,
  },
}

export const CHART_PROPS = {
  ...CARD_PROPS,
  data: {
    // Example: [
    //   { prop1: 2, prop2: 4, prop5: '2023-10-01' },
    //   { prop1: 5, prop2: 1, prop5: '2023-10-02' },
    // ]
    type: Array,
    required: false,
  },
  dataSetsConfig: {
    // Example: [
    //   { property: 'prop1', label: 'Users' },
    //   { property: 'prop2', label: 'Logins' },
    // ]
    type: Array,
    required: true,
  },
  showDataLabels: {
    type: Boolean,
    default: false,
  },
  showLegend: {
    type: Boolean,
    default: true,
  },
  labelsKey: {
    type: String,
    required: true,
  },
  height: {
    // Example: 200px or 1.5rem
    type: String,
    required: false,
    default: '300px',
  },
}
